import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";
import "lazysizes";

import "@splidejs/splide/dist/css/splide.min.css";
import "@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css";

window.Video = Video;
window.Splide = Splide;
